// removed by extract-text-webpack-plugin
module.exports = {"BreakpointFromMedium":"(min-width: 640px)","socialBelongingContainer":"Gc82c05","wizardWithoutImagesContainer":"G7845c8","bold":"G922540 G13d4db","socialPadding":"G514cb6"};